import { render } from "./ToolsSuggestionsDisplay.vue?vue&type=template&id=80808006&scoped=true"
import script from "./ToolsSuggestionsDisplay.vue?vue&type=script&lang=js"
export * from "./ToolsSuggestionsDisplay.vue?vue&type=script&lang=js"

import "./ToolsSuggestionsDisplay.vue?vue&type=style&index=0&id=80808006&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80808006"]])

export default __exports__